if (!customElements.get("product-list")) {
  class ProductList extends HTMLElement {
    constructor() {
      super();
      this.swiperContainer = this.querySelector(".swiper");
      this.columnsMobile = parseInt(this.dataset.columnsMobile) || 2;
      this.columnsDesktop = parseInt(this.dataset.columnsDesktop) || 4;
      this.productCount = parseInt(this.dataset.productCount) || 0;
      this.swiper = null;

      this.resizeHandler = this.debounce(
        this.initOrUpdateSwiper.bind(this),
        200,
      );
    }

    connectedCallback() {
      this.initOrUpdateSwiper();
      window.addEventListener("resize", this.resizeHandler);

      if (Shopify.designMode) {
        document.addEventListener(
          "shopify:section:load",
          this.handleSectionLoad.bind(this),
        );
      }
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.resizeHandler);
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      if (Shopify.designMode) {
        document.removeEventListener(
          "shopify:section:load",
          this.handleSectionLoad.bind(this),
        );
      }
    }

    handleSectionLoad(event) {
      if (
        event.detail.sectionId !==
        this.closest(".shopify-section").id.replace("shopify-section-", "")
      )
        return;
      if (this.swiper) this.swiper.destroy(true, true);

      // Update data attributes in case settings changed
      this.columnsMobile = parseInt(this.dataset.columnsMobile) || 2;
      this.columnsDesktop = parseInt(this.dataset.columnsDesktop) || 4;
      this.productCount = parseInt(this.dataset.productCount) || 0;

      this.initOrUpdateSwiper();
    }

    initOrUpdateSwiper() {
      if (!this.swiperContainer) return;

      const isMobile = window.innerWidth < 750;
      const columns = isMobile ? this.columnsMobile : this.columnsDesktop;

      if (this.productCount > columns) {
        if (!this.swiper) {
          this.initSwiper();
        } else {
          this.swiper.update();
        }
      } else {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
        this.querySelector(".swiper-wrapper").classList.add(
          "product-list-grid",
        );
        this.swiperContainer.classList.remove("swiper-initialized");
      }
    }

    initSwiper() {
      if (typeof Swiper === "undefined") {
        setTimeout(this.initSwiper.bind(this), 100);
        return;
      }

      this.querySelector(".swiper-wrapper").classList.remove(
        "product-list-grid",
      );

      this.swiper = new Swiper(this.swiperContainer, {
        slidesPerView: this.columnsMobile + 0.5,
        spaceBetween: 16,
        breakpoints: {
          750: {
            slidesPerView: this.columnsDesktop,
            spaceBetween: 32,
          },
        },
        on: {
          init: () => {
            this.classList.add("swiper-initialized");
          },
        },
      });
    }

    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
  }

  customElements.define("product-list", ProductList);
}
